<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title">ALMOST DARK</p>
<p class="subtitle">A Novel</p>
<p class="authorname">Letitia Trent</p>
<p class="publisher"><img alt="colophon" src="images/fig_02.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AlmostDark1.vue?59853ed6